import {
    FETCH_PROCEDURES_REQUEST,
    FETCH_PROCEDURES_SUCCESS,
    FETCH_PROCEDURES_FAILURE,
    FETCH_PROCEDURES_COUNT_REQUEST,
    FETCH_PROCEDURES_COUNT_SUCCESS,
    FETCH_PROCEDURES_COUNT_FAILURE,
    PROCEDURES_FILTER_ENABLED,
    PROCEDURES_FILTER_CLEAR
} from "../actions/procedureActions";

const initialState = {
    procedureList: [],
    totalCount: 0,
    isLoading: false,
    error: null,
    countLoading: false,
    procedureFilter: false
};

export const proceduresReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROCEDURES_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PROCEDURES_SUCCESS:
            return { ...state, procedureList: action.payload, isLoading: false };

        case FETCH_PROCEDURES_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_PROCEDURES_COUNT_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_PROCEDURES_COUNT_SUCCESS:
            return { ...state, totalCount: action.payload, countLoading: false };

        case FETCH_PROCEDURES_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        case PROCEDURES_FILTER_ENABLED:
            return { ...state, procedureFilter: action.payload };

        case PROCEDURES_FILTER_CLEAR:
            return { ...state, procedureFilter: action.payload };

        default:
            return state;
    }
};
